import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolder2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-2"><path d="M2 6.75C2 4.67893 3.67893 3 5.75 3H8.72581C9.70258 3 10.6408 3.38112 11.3409 4.06228L11.6496 4.36263C12.0696 4.77133 12.6326 5 13.2186 5H18.25C20.3211 5 22 6.67893 22 8.75V9.74973C21.3733 9.27896 20.5942 9 19.75 9H4.25C3.4058 9 2.62675 9.27896 2 9.74973V6.75Z" fill="currentColor"/><path d="M2 12.75V16.25C2 18.3211 3.67893 20 5.75 20H18.25C20.3211 20 22 18.3211 22 16.25V12.75C22 11.5074 20.9926 10.5 19.75 10.5H4.25C3.00736 10.5 2 11.5074 2 12.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFolder2;
